import React from "react";
import ReactDOM from "react-dom";
// Apollo
import ApolloClient from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { ApolloProvider } from "@apollo/react-hooks";
import { InMemoryCache } from "apollo-cache-inmemory";
import { HttpLink } from "apollo-link-http";
import { gql } from "apollo-boost";
// Auth0
import createAuth0Client from "@auth0/auth0-spa-js";
import config from "./config.json";
// UI
import App from "./app";

const cache = new InMemoryCache();

/* export const typeDefs = gql`
  extend type Query {
    waitingForAuthentication: Boolean!
    isAuthenticated: Boolean!
    name: String
    picture: String
    backgroundJobs: [BackgroundJob!]!
  }

  extend type Mutation {
    loginWithRedirect(path: String!): Boolean
  }

  type BackgroundJob {
    requestId: ID!
    origin: String!
    status: String!
    timestamp: String!
    completedAt: String
    description: String
    cooperative: String
  }
`; */
export const typeDefs = gql`
  extend type Query {
    waitingForAuthentication: Boolean!
    isAuthenticated: Boolean!
    name: String
    picture: String
  }

  extend type Mutation {
    loginWithRedirect(path: String!): Boolean
  }
`;

let oauthClient;

const httpLink = createHttpLink({
  //uri: 'https://plqpw42y57.execute-api.us-west-2.amazonaws.com/dev/graphql'  // 'http://localhost:4000/graphql'
  uri: `${process.env.REACT_APP_GRAPHQL_API_ENDPOINT}`
});

const authLink = setContext((_, { headers }) => {
  // Così legge direttamente dalla cache e non viene mai persistito nel browser..
  // in alternativa si può usare il local storage
  const token = cache.data.data.ROOT_QUERY && cache.data.data.ROOT_QUERY.email;

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ""
    }
  };
});

const client = new ApolloClient({
  cache,
  link: authLink.concat(httpLink),
  typeDefs,
  resolvers: {
    Query: {
      backgroundJobs: () => [
        {
          __typename: "BackgroundJob",
          requestId: "bf2eb4a7-17cd-4f01-88e8-63715b2c3407",
          origin: "graphql_createcontractrequests",
          status: "SUCCESS",
          timestamp: "2026-04-08T08:58:44.156Z",
          completedAt: "2026-04-08T09:02:11.000Z",
          description: "Richieste Assunzioni - DIGITAL WEB AGENCY SRL",
          cooperative: "DIGITAL WEB AGENCY SRL"
        },
        {
          __typename: "BackgroundJob",
          requestId: "a1b2c3d4-0000-0000-0000-111122223333",
          origin: "graphql_createpaypacketbundle",
          status: "IN_PROGRESS",
          timestamp: new Date(Date.now() - 90000).toISOString(),
          completedAt: null,
          description: "Generazione Buste Paga - Aprile 2026",
          cooperative: "COOP SOCIALE ESEMPIO SRL"
        },
        {
          __typename: "BackgroundJob",
          requestId: "e5f6g7h8-aaaa-bbbb-cccc-ddddeeee0001",
          origin: "graphql_createsalaries",
          status: "QUEUED",
          timestamp: new Date(Date.now() - 30000).toISOString(),
          completedAt: null,
          description: null,
          cooperative: "ALPHA COOPERATIVE SRL"
        },
        {
          __typename: "BackgroundJob",
          requestId: "zz99xx88-1234-5678-abcd-ef0123456789",
          origin: "graphql_createpaypacketbundle",
          status: "ERROR",
          timestamp: "2026-04-07T14:20:00.000Z",
          completedAt: "2026-04-07T14:21:45.000Z",
          description: "Generazione Buste Paga - Marzo 2026",
          cooperative: "BETA CONSORTIUM SRL"
        }
      ]
    },
    Mutation: {
      loginWithRedirect: async (obj, { path }, context, info) => {
        try {
          await oauthClient.loginWithRedirect({
            appState: { targetUrl: path }
          });
          return true;
        } catch (err) {
          console.log(err);
          return false;
        }
      },
      logout: async (obj, variables, context, info) => {
        await oauthClient.logout({
          returnTo: window.location.origin
        });
      }
    }
  }
});

const data = {
  waitingForAuthentication: true,
  isAuthenticated: false,
  name: "",
  email: "",
  picture: ""
};

cache.writeData({
  data
});

// A function that routes the user to the right place
// after login
const onRedirectCallback = appState => {
  window.history.replaceState(
    {},
    document.title,
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

const initAuth0 = async () => {

  if (process.env.REACT_APP_AUTH_AS) {
    data.email = process.env.REACT_APP_AUTH_AS //"test.consorzi@gmail.com"
    data.isAuthenticated = true;
    data.waitingForAuthentication = false;          
    client.writeData({ data });

    return;
  }  

  oauthClient = await createAuth0Client({
    domain: process.env.REACT_APP_AUTH0_DOMAIN || config.domain,
    client_id: process.env.REACT_APP_AUTH0_CLIENT_ID || config.clientId,
    redirect_uri: window.location.origin
  });


  if (window.location.search.includes("code=")) {
    const { appState } = await oauthClient.handleRedirectCallback();
    onRedirectCallback(appState);
  }

  const isAuthenticated = await oauthClient.isAuthenticated();

  /*
  if (isAuthenticated) {
    const { name, email, picture } = await oauthClient.getUser();

    data.isAuthenticated = isAuthenticated;
    data.name = name;
    data.email = email;
    data.picture = picture;
  }

  data.waitingForAuthentication = false;
  client.writeData({ data });
  */

  if (isAuthenticated) {    
    const { name, email, picture } = await oauthClient.getUser();

    console.log( window.location )

    //data.isAuthenticated = isAuthenticated;
    data.name = name;
    data.email = email;
    data.picture = picture;

    client.writeData({ data });

    try {
      const response = await client.query({
        query: gql`
          query me {
            me {
              type                      
              userName
              lastName
              firstName 
            }
          }
      `});
      data.isAuthenticated = (response.data.me.type.toLowerCase().includes('internal'));
    } catch (e) {
      console.log(e)
      data.isAuthenticated = false;
    } finally {
      data.waitingForAuthentication = false;          
      client.writeData({ data });
    }
    return
  }

  data.waitingForAuthentication = false;
  client.writeData({ data });
};

initAuth0();

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById("root")
);
